import React, { useCallback, useEffect, useMemo, useState } from "react";
import { DispatchTransactionEvent } from "../events/events";
import {
  ShowError, DROPDOWN_LIST_NONE,
  JSON_KEY_MESSAGE_TYPE, EVENT_TOPIC_FOR_TRANSACTION_SERVER, JSON_KEY_SUBMITTER, JSON_KEY_STATUS,
  ITEM_STATUS, ITEM_CREATE, ITEM_MODIFY, ConvertToTradingAccountTypeId, 
  StatusSimpleOptions, OTHER_NAME, OMNIBUS_NAME, INSTITUTIONAL_NAME, HOUSE_NAME, GENERAL_NAME, FOREIGN_NAME,
  FOREIGN_ID, GENERAL_ID, HOUSE_ID, INSTITUTIONAL_ID, OMNIBUS_ID, OTHER_ID, EVENT_TYPE_TRADING_ACCOUNT_MODIFY,
  EVENT_TYPE_TRADING_ACCOUNT_CREATE, EVENT_TYPE_CHANGE_TRADING_ACCOUNT_STATUS,
  JSON_KEY_TRADING_ACCOUNT_TYPE, JSON_KEY_TRADING_ACCOUNT, JSON_KEY_DESCRIPTION,
  SUSPENDED,
  JSON_KEY_FIRM,
  JSON_KEY_USER,
  NO,
  JSON_KEY_WITHDRAW_ALL_ORDERS,
  SUSPEND,
  ConvertStatus,
  ConvertStatusFromNameToId,
  STATUS_SUSPEND,
  STATUS_ACTIVE,
  YES,
  ConfirmConfirmCancelAndSubmit,
  ITEM_CANCEL_ALL_ORDERS,
  EVENT_TYPE_TRADING_ACCOUNT_CANCEL_ALL_ORDERS,
} from "../../common/common";
import { Tab, Tabs, TabList, TabPanel } from "react-tabs";
import "../tabs/tabs.css";
import { Button } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useSelector } from "react-redux";
import { selectTSUserId } from "../../redux/globalsSlice";
import { MSGTYPE_TRADING_ACCOUNT_CANCEL_ALL_ORDERS, MSGTYPE_TRADING_ACCOUNT_CHANGE_STATUS, MSGTYPE_TRADING_ACCOUNT_CREATE, MSGTYPE_TRADING_ACCOUNT_MODIFY, } from "../../common/msg_types";
import { RenderDropdown, InputField } from "../../common/utilies";
import { yesNoOptions } from "../../common/convert_functions";

const TradingAccountsAdminForm = ({ rowData, onClose, tradingAccountOptions, userOptions, firmOptions }) => {
   const typeOptions = useMemo(() => ([
      { id: FOREIGN_ID, name: FOREIGN_NAME },
      { id: GENERAL_ID, name: GENERAL_NAME },
      { id: HOUSE_ID, name: HOUSE_NAME },
      { id: INSTITUTIONAL_ID, name: INSTITUTIONAL_NAME },
      { id: OMNIBUS_ID, name: OMNIBUS_NAME },
      { id: OTHER_ID, name: OTHER_NAME },
   ]), []);

   const userId = useSelector(selectTSUserId);
   const [selectedTabIndex, setSelectedTabIndex] = useState(0);  

   // Form handling
   const {
      handleSubmit,
   } = useForm({});

   // tab 1
   const [code, setCode] = useState(rowData?.code);
   const [status, setStatus] = useState(SUSPEND);
   const [withdrawAllOrders, setWithdrawAllOrders] = useState(NO);
   const [cancelAllOrdersDisabled, setCancelAllOrdersDisabled] = useState(false);

   // tab 2 & 3
   const [type, setType] = useState(DROPDOWN_LIST_NONE);
   const [description, setDescription] = useState(rowData?.descr);
   const [firm, setFirm] = useState(DROPDOWN_LIST_NONE);
   const [subjectUser, setUser] = useState(DROPDOWN_LIST_NONE);
   
   
   const handleCancel = () => {
      if (document.activeElement instanceof HTMLElement) {
      document.activeElement.blur();
      }
      onClose(); // your modal close function
   };

   const onCodeDropDownChange = useCallback((e) => {setCode(e.target.value)}, [setCode]);
   const onFirmDropDownChange = useCallback((e) => {setFirm(e.target.value)}, [setFirm]);
   const onStatusDropDownChange = useCallback((e) => {setStatus(e.target.value)}, [setStatus]);
   const onTypeDropDownChange = useCallback((e) => {setType(e.target.value)}, [setType]);
   const onUserDropDownChange = useCallback((e) => {setUser(e.target.value)}, [setUser]);
   const onYesNoDropDownChange = useCallback((e) => {setWithdrawAllOrders(e.target.value)}, [setWithdrawAllOrders]);

   const onCodeModifyDropDownChange = (e) => {
      setCode(e.target.value);
      setDescription('');
      setFirm(DROPDOWN_LIST_NONE);
      setType(OTHER_ID);
      setStatus(SUSPENDED);
   };

   // const ConfirmAndSubmit = async ({ title, text, item }) => {
   //    const confirmed = await confirmationDialog({ title, text });
   //    if (confirmed) handleStatusConfirmationSubmit(item);
   // };

   const handleStatusConfirmationSubmit = (submitItem) => {
      const messageMap = {
         [ITEM_STATUS]: {
            messageType: MSGTYPE_TRADING_ACCOUNT_CHANGE_STATUS,
            eventType: EVENT_TYPE_CHANGE_TRADING_ACCOUNT_STATUS,
            payload: {
               [JSON_KEY_TRADING_ACCOUNT]: code,
               [JSON_KEY_SUBMITTER]: userId,
               [JSON_KEY_STATUS]: status,
               [JSON_KEY_WITHDRAW_ALL_ORDERS]: withdrawAllOrders,
            }
         },
         [ITEM_CANCEL_ALL_ORDERS]: {
            messageType: MSGTYPE_TRADING_ACCOUNT_CANCEL_ALL_ORDERS,
            eventType: EVENT_TYPE_TRADING_ACCOUNT_CANCEL_ALL_ORDERS,
            payload: {
               [JSON_KEY_TRADING_ACCOUNT]: code,
               [JSON_KEY_SUBMITTER]: userId,
               [JSON_KEY_STATUS]: status,
            }
         },
         [ITEM_CREATE]: {
            messageType: MSGTYPE_TRADING_ACCOUNT_CREATE,
            eventType: EVENT_TYPE_TRADING_ACCOUNT_CREATE,
            payload: {
               [JSON_KEY_SUBMITTER]: userId,
               [JSON_KEY_TRADING_ACCOUNT]: code,
               [JSON_KEY_DESCRIPTION]: description,
               [JSON_KEY_TRADING_ACCOUNT_TYPE]: type,
               ...(firm !== DROPDOWN_LIST_NONE && { [JSON_KEY_FIRM]: firm }),
               ...(subjectUser !== DROPDOWN_LIST_NONE && { [JSON_KEY_USER]: subjectUser }),
            }
         },
         [ITEM_MODIFY]: {
            messageType: MSGTYPE_TRADING_ACCOUNT_MODIFY,
            eventType: EVENT_TYPE_TRADING_ACCOUNT_MODIFY,
            payload: {
               [JSON_KEY_SUBMITTER]: userId,
               [JSON_KEY_TRADING_ACCOUNT]: code,
               [JSON_KEY_DESCRIPTION]: description,
               [JSON_KEY_TRADING_ACCOUNT_TYPE]: type,
               [JSON_KEY_WITHDRAW_ALL_ORDERS]: withdrawAllOrders,
               ...(subjectUser !== DROPDOWN_LIST_NONE && { [JSON_KEY_USER]: subjectUser }),
               ...(firm !== DROPDOWN_LIST_NONE && { [JSON_KEY_FIRM]: firm }),
            }
         }
      };

      const selected = messageMap[submitItem];
      if (selected) {
         const { messageType, eventType, payload } = selected;
         DispatchTransactionEvent(EVENT_TOPIC_FOR_TRANSACTION_SERVER, eventType, {
            [JSON_KEY_MESSAGE_TYPE]: messageType,
            ...payload
         });
      } else {
         console.warn("TradingAccountsAdminForm unknown submit item:", submitItem);
      }
   };

   const handleCancelAllOrdersSubmit = () => {
      if (!code) return ShowError("Code is missing");
      if (withdrawAllOrders === NO) return ShowError("Cancel All Orders must be YES");

      ConfirmConfirmCancelAndSubmit({
         title: "Account Cancel All Orders",
         text: `Do you want to cancel all orders on the account: ${code}`,
         item: ITEM_CANCEL_ALL_ORDERS,
         cancel_all: withdrawAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      onClose(); // your modal close function
   };

   const handleStatusSubmit = () => {
      ConfirmConfirmCancelAndSubmit({
         title: "Trading Account Status Change",
         text: `Setting Trading Account ${code} to ${ConvertStatus(status)}`,
         item: ITEM_STATUS,
         cancel_all: withdrawAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });
      onClose(); // your modal close function
   };

   const ValidateFields = () => {
      if (!code) return "Code is missing";
      if (!description) return "Description is missing";
      if (!type) return "Type is missing";
      if (!status) return "Status is missing";
      return null;
   };

   const handleCreateSubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmConfirmCancelAndSubmit({
         title: "Create TradingAccount",
         text: `Creating new trading account: ${code}`,
         item: ITEM_CREATE,
         cancel_all: NO,
         onSubmit: handleStatusConfirmationSubmit,
      });

      // ConfirmAndSubmit({
      //    title: "Create TradingAccount",
      //    text: `Creating new trading account: ${code}`,
      //    item: ITEM_CREATE,
      // });
      onClose(); // your modal close function
   };

   const handleModifySubmit = () => {
      const error = ValidateFields();
      if (error) return ShowError(error);

      ConfirmConfirmCancelAndSubmit({
         title: "Modify TradingAccount",
         text: `Modifying trading account: ${code}`,
         item: ITEM_MODIFY,
         cancel_all: withdrawAllOrders,
         onSubmit: handleStatusConfirmationSubmit,
      });

      // ConfirmAndSubmit({
      //    title: "Modify TradingAccount",
      //    text: `Modifying trading account: ${code}`,
      //    item: ITEM_MODIFY,
      // });
      onClose(); // your modal close function
   };

   useEffect(() => {
      if (selectedTabIndex === 2) {
         setStatus(SUSPEND);
      }
   }, [selectedTabIndex]);

   useEffect(() => {
      if (!rowData) return;
         setCode(rowData.code || '');
         setDescription(rowData.descr || '');
         setFirm(rowData.firm || DROPDOWN_LIST_NONE);
         setUser(rowData.user || DROPDOWN_LIST_NONE);
         setStatus(rowData?.status ? ConvertStatusFromNameToId(rowData.status) : SUSPEND);
         setType(ConvertToTradingAccountTypeId(rowData.ta_type || DROPDOWN_LIST_NONE));
   }, [rowData]);

   // Sync behavior when status changes
   useEffect(() => {
      if (status === STATUS_SUSPEND) {
         setWithdrawAllOrders(YES);
         setCancelAllOrdersDisabled(true);
      } else if (status === STATUS_ACTIVE) {
         setWithdrawAllOrders(NO);
         setCancelAllOrdersDisabled(false);
      } else {
         setCancelAllOrdersDisabled(false); // fallback for other statuses
      }
   }, [status]);

   return (
      <div className="admin-form">
         <div className="admin-tabs">
         <h2 className="center-heading">Trading Account Administration</h2>
         <Tabs selectedIndex={selectedTabIndex} onSelect={setSelectedTabIndex} forceRenderTabPanel={true} className="admin-tabs" >
            <TabList>
               <Tab>Change Status</Tab>
               <Tab>Modify Account</Tab>
               <Tab>Create Account</Tab>
               <Tab>Cancel All Orders</Tab>
            </TabList>

            {/* Tab 1: Change Status */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleStatusSubmit)}>
               <div className="top" style={{ whiteSpace: 'nowrap' }}>
                  {RenderDropdown("Trading Account", code, tradingAccountOptions, onCodeDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown(
                  "Withdraw All Orders",
                  status === STATUS_SUSPEND ? YES : NO,  
                  yesNoOptions,
                  () => {},                              
                  true                                   
                  )}
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 2: Modify TradingAccount */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleModifySubmit)}>
               <div className="top" style={{ whiteSpace: 'nowrap' }}>
                  {RenderDropdown("Trading Account", code, tradingAccountOptions, onCodeModifyDropDownChange)}
               </div>
               <div>
                  <InputField label="Description" value={description} onChange={setDescription} />
               </div>

               <div className="top">
                  {RenderDropdown("Firm", firm, firmOptions, onFirmDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("User", subjectUser, userOptions, onUserDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Type", type, typeOptions, onTypeDropDownChange)}
               </div>
               {/*
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange)}
               </div>
               
               <div className="top" style={{ whiteSpace: 'nowrap' }}>
                  {RenderDropdown("Withdraw All Orders", withdrawAllOrders, yesNoOptions, onYesNoDropDownChange)}
               </div>
               */}
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>            
            
            {/* Tab 3: Create TradingAccount */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCreateSubmit)}>
               <div style={{ whiteSpace: 'nowrap' }}>
                  <InputField label="Trading Account Code" value={code} onChange={setCode} />
               </div>

               <div>
                  <InputField label="Description" value={description} onChange={setDescription} />
               </div>

               <div className="top">
                  {RenderDropdown("Firm", firm, firmOptions, onFirmDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("User", subjectUser, userOptions, onUserDropDownChange)}
               </div>

               <div className="top">
                  {RenderDropdown("Type", type, typeOptions, onTypeDropDownChange)}
               </div>

               {/*
               <div className="top">
                  {RenderDropdown("Status", status, StatusSimpleOptions, onStatusDropDownChange, true)}
               </div>
               */}
               
               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

            {/* Tab 4: Cancel All Orders */}
            <TabPanel>
               <form onSubmit={handleSubmit(handleCancelAllOrdersSubmit)}>
               <div className="top" style={{ whiteSpace: 'nowrap' }}>
                  {RenderDropdown("Trading Account", code, tradingAccountOptions, onCodeDropDownChange)}
               </div>

               <div className="top" style={{ whiteSpace: 'nowrap' }}>
                  {RenderDropdown("Withdraw All Orders", withdrawAllOrders, yesNoOptions, onYesNoDropDownChange, cancelAllOrdersDisabled)}
               </div>

               <div className="buttons">
                  <Button className="left-button" variant="secondary" size="lg" onClick={handleCancel}>
                     Cancel
                  </Button>
                  <Button className="right-button" variant="success" size="lg" type="submit">
                     Submit
                  </Button>
               </div>
               </form>
            </TabPanel>

         </Tabs>
         </div>
      </div>
   );
};

export default TradingAccountsAdminForm;
